import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/reset.css";
import "./assets/css/common.css";
import "./assets/css/rest.css";
import "./assets/iconFont/iconfont.css";
import productList from "./assets/js/product";
import utils from "./utils/util"
import i18n from './common/lang';
// 导入 Ant Design Vue 组件库
import Antd from 'ant-design-vue';
// 导入 Ant Design Vue 样式
import 'ant-design-vue/dist/antd.css';

// 全局初始化
import './utils/init';

import Cookies from 'js-cookie';
// 使用 Ant Design Vue
Vue.use(Antd);

Vue.config.productionTip = false;
// Vue.use(ElementUI);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
Vue.prototype.$productList = productList;
Vue.prototype.$utils = utils;
Vue.prototype.$cookie = Cookies;

localStorage.setItem("language", Cookies.get("language") || "zh");

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
